import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useESClass(data = {}) {
  const { enabled = false, queryParams = '' } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getESClass() {
    return privateFetch.get(`/v1/admin/class${queryParams}`).then((res) => res.data);
  }

  return useQuery(['ES-class', { data }], getESClass, { enabled });
}

export default useESClass;
